<template>
    <v-dialog v-model="dialog" width="350" persistent transition="dialog-bottom-transition" @keydown.esc="close">
        <v-card class="scouting-add-edit-dialog-card">
            <v-toolbar dark color="primary">
                <v-btn icon dark  @click="close">
                    <v-icon large>close</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-toolbar-title>Images</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                </v-toolbar-items>
            </v-toolbar>            
            <v-container>                
                <v-layout row wrap>
                    <v-flex v-if="images == null">
                        <v-alert type="info" :value="true">No Images</v-alert>
                    </v-flex>
                    <v-flex shrink v-for="(item, index) in imagesWithUrls" :key="index">
                        <v-container class="pa-0" fluid>
                            <v-layout row>
                                <v-flex xs12>
                                    <v-btn class="image-expand-button" icon color="primary" @click="showImageExpanded(item.photoURL)">
                                        <v-icon>zoom_out_map</v-icon>
                                    </v-btn>
                                    <v-img v-if="dialog" class="ma-2" contain :src="item.photoURL" alt="Image" :lazy-src="require('@/assets/loading.png')" width="280px" />
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-flex>
                </v-layout>
            </v-container>                
            <v-layout wrap class="dialog-action-buttons">
                <v-flex xs12>
                    <v-btn block color="error" @click="close">close</v-btn>
                </v-flex>
            </v-layout>            
        </v-card>
        <v-dialog v-model="showImageDialog" fullscreen>
            <v-toolbar dark color="primary">
                <v-btn icon dark  @click="showImageDialog = false">
                    <v-icon large>close</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-toolbar-title>Image</v-toolbar-title>                
                <v-spacer></v-spacer>
                <v-toolbar-items>
                </v-toolbar-items>
            </v-toolbar>
            <v-img v-if="imageSrc" contain :src="imageSrc" :lazy-src="require('@/assets/loading.png')"/>
        </v-dialog>
    </v-dialog>
</template>
<script>
export default {
    data() {
        return {
            showImageDialog:false,
            imageSrc:null,
            imagesWithUrls:[]
        }
    },
    props: [
        "dialog",
        "images",
        "imageAuthToken"
    ],
    components: {
    },
    methods: {
       close() {
           this.$emit("close");
        },
        formatPhotoURL(photoName) {
            return process.env.VUE_APP_API_URI + '/pestconfigurations/photoData?' + [
                'photoName=' + photoName,
                'Token=' + this.imageAuthToken,
                'TimestampToStopTheCaching=' + Date.now()
            ].join('&');
        },
        async loadImageAuthToken(){
            this.imageAuthToken = await this.$store.dispatch("UserStore/acquireImageAuthToken");
        },
        showImageExpanded(url) {
            this.showImageDialog = true;
            this.imageSrc = url;
        },
    },
    async created() {
        await this.loadImageAuthToken();

        if(this.dialog && this.images) {
            this.images.forEach(i => {
                let url = this.formatPhotoURL(i.Name);
                this.imagesWithUrls.push({ photoURL: url});
            });            
        }
    }
}
</script>
<style scoped>
.image-expand-button {
    position: absolute;
    z-index: 9999;
    margin-top: 15px;
    margin-left: 15px;
}
</style>
